import { Textarea } from "@/components/ui/textarea";

export function AutoTextarea({ value, onChange, readOnly, bad, testId, placeholder, minRows = 2 }) {
  const text = value || "";
  const lines = text.split("\n").reduce((n, l) => n + Math.max(1, Math.ceil(l.length / 120)), 0);
  const rows = Math.min(14, Math.max(minRows, lines));
  return (
    <Textarea value={text} onChange={(e) => onChange(e.target.value)} disabled={readOnly} rows={rows} placeholder={placeholder}
      className={`text-sm leading-relaxed resize-y bg-white dark:bg-slate-900 rounded-md ${bad ? "border-red-400 ring-1 ring-red-200" : ""}`} data-testid={testId} />
  );
}
